import Advertisement from "@components/Elements/Advertisement/Advertisement";
import { GoogleAdsSlotFactory } from "@components/Elements/Advertisement/helpers";
import { AdvertisementTypeEnum } from "@src/app/types/Ads.d";
import { twMerge } from "tailwind-merge";

type AdsImuProps = {
  sectionName?: string;
  rootClassName?: string;
  index?: number;
};

/**
 * TM IMU Ads
 * Description: The IMU ads to render required ads.
 * @sectionName - name of section or page
 * @rootClassName - to override the classes
 */

export function AdsImu1({ sectionName, rootClassName }: AdsImuProps) {
  return (
    <div className="mb-6 lg:min-h-60 border-b border-gray-1050">
      <Advertisement
        rootClassName={twMerge("flex justify-center", rootClassName)}
        adUnitProps={{
          type: AdvertisementTypeEnum.IMU1,
          slot: GoogleAdsSlotFactory.imu1(sectionName),
          id: "dfp-ad-imu1",
        }}
      />
    </div>
  );
}

export function AdsImu2({ sectionName, rootClassName }: AdsImuProps) {
  return (
    <div className="mb-6 lg:min-h-60 border-b border-gray-1050">
      <Advertisement
        rootClassName={twMerge("flex justify-center", rootClassName)}
        adUnitProps={{
          type: AdvertisementTypeEnum.IMU2,
          slot: GoogleAdsSlotFactory.imu2(sectionName),
        }}
      />
    </div>
  );
}
